
define('text!views/shared/form/input/zipcode_component.html',[],function () { return '<label><%- this.field.label %></label>\r\n<input type="number" name="" class="" placeholder="<%= this.field.placeholder %>" autocomplete="<%- this.field.autocomplete %>" />\r\n<div class="form-input-feedback js-form-input-feedback"></div>';});

